import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoStockChartMixin from './KendoStockChartMixin'

export default {
    name: 'kendo-stockchart',
    mixins: [ KendoStockChartMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('div', defaultSlot)
    },
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoStockChart/index.js